import { useFormik } from "formik";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { NoteState } from "../../context/notes/NoteState";
import UserServices from "../../UserServices/UserServices";
import { trainerPkgSell } from "../schemas";
import moment from "moment";

export default function SellTrainerPkg(props) {
  const { state, dispatch: ctxDispatch } = useContext(NoteState);
  const { branch_id } = state;
  const [loading, setLoading] = useState(false);

  const [paySplitError, setPaySplitError] = useState("");

  const [trainerNames, setTrainerNames] = useState([]);
  const [trainerPkgsTypes, setTrainerPkgsTypes] = useState([]);

  const [pakagesTypes, setPakagesTypes] = useState([]);

  const [discountError, setDiscountError] = useState("");

  const [membershipFee, setMembershipFee] = useState("0");
  const [payAfterError, setPayAfterError] = useState("");
  const [clientName, setClientName] = useState("");
  const { id } = useParams();

  const date = new Date();
  const futureDate = date.getDate();
  date.setDate(futureDate);
  const defaultValue = date.toLocaleDateString("en-CA");

  var dateSelected = moment(defaultValue).format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(dateSelected);
  const [endDate, setEndDate] = useState(dateSelected);

  useEffect(() => {
    const gettrainerNames = async (br_Id) => {
      try {
        const responce = await UserServices.TrainerName(br_Id);

        const res = responce.data.data;
        const results = [];
        res.map((value) => {
          results.push({
            id: value.id,
            name: value.first_name + " " + value.last_name,
          });
        });
        setTrainerNames([{ name: "Select Trainer", id: "" }, ...results]);
      } catch (err) {
        console.log(err);

        setTrainerNames([{ name: "No Trainer Found", id: "" }]);
      }
    };

    const nameClients = async () => {
      try {
        const responce = await UserServices.getClientsNameById(branch_id, id);

        setClientName(
          responce.data.data[0].first_name +
            " " +
            responce.data.data[0].last_name
        );
      } catch (err) {
        console.log(err);
        setClientName("");
      }
    };
    nameClients();

    gettrainerNames(branch_id);
  }, []);

  const getPkgTypes = async (e) => {
    var trainer_cat = e.target.value;

    try {
      const responce = await UserServices.trainerPkgTypesList(
        branch_id,
        values.trainer,
        "2",
        trainer_cat
      );

      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.id,
          name: value.name,
        });
      });
      setPakagesTypes([
        { name: "Select Trainer Packages", id: "" },
        ...results,
      ]);
    } catch (err) {
      setPakagesTypes([{ name: "No Trainer Packages Found", id: "" }]);

      console.log(err);
    }
  };

  const getPkgFee = async (e) => {
    var pkg_type = e.target.value;
    var sDate = moment(values.sdate).format("YYYY-MM-DD");
    try {
      const responce = await UserServices.pkgFee(pkg_type, sDate, values.qty);

      const price = responce.data.price;
      const sdate = responce.data.startDate;
      const eDate = responce.data.endDate;
      setEndDate(eDate);
      setStartDate(sdate);

      setMembershipFee(price);
      values.package_full_price = price;
    } catch (err) {
      console.log(err);
      setMembershipFee("");
      values.package_full_price = "";
    }
  };

  const changeStartDate = async (e) => {
    var date = e.target.value;
    var sDate = moment(date).format("YYYY-MM-DD");

    try {
      const responce = await UserServices.pkgFee(
        values.pkgType,
        sDate,
        values.qty
      );

      const price = responce.data.price;
      const sdate = responce.data.startDate;
      const eDate = responce.data.endDate;
      setEndDate(eDate);
      setStartDate(sdate);
      setMembershipFee(price);
      values.package_full_price = price;
    } catch (err) {
      console.log(err);

      setMembershipFee("0");
      values.package_full_price = "0";
    }
  };
  const changeQty = async (e) => {
    var qty = e.target.value;
    var sDate = moment(values.sdate).format("YYYY-MM-DD");
    try {
      const responce = await UserServices.pkgFee(values.pkgType, sDate, qty);

      const price = responce.data.price;
      const sdate = responce.data.startDate;
      const eDate = responce.data.endDate;
      setEndDate(eDate);
      setStartDate(sdate);
      setMembershipFee(price);
      values.package_full_price = price;
    } catch (err) {
      console.log(err);

      setMembershipFee("0");
      values.package_full_price = "0";
    }
  };

  const getTrainerPkgs = async (e) => {
    var trainer_id = e.target.value;

    try {
      const responce = await UserServices.trainerPkgList(trainer_id);

      const res = responce.data.data;
      const results = [];
      res.map((value) => {
        results.push({
          id: value.category_id,
          name: value.name,
        });
      });
      setTrainerPkgsTypes([
        { name: "Select Package Type", id: "" },
        ...results,
      ]);
      setPakagesTypes([{ name: "Select Trainer Packages", id: "" }]);
    } catch (err) {
      setTrainerPkgsTypes([{ name: "No Package Type Found", id: "" }]);
      setPakagesTypes([{ name: "Select Trainer Packages", id: "" }]);

      console.log(err);
    }
  };

  const verifyDiscount = async (e) => {
    var discount_price = e.target.value;
    var packagePrice = parseFloat(values.package_full_price) || parseFloat(membershipFee) || 0;
    if (discount_price !== "") {
      if (
        values.discount_type === "Percentage" &&
        values.discount_type !== "" &&
        packagePrice > 0
      ) {
        if (discount_price > 100) {
          values.pay_after_dis = "0";
          setDiscountError(
            "Maximum discount must be equal to or less than 100%"
          );
        } else if (discount_price < 0) {
          values.pay_after_dis = "0";
          setDiscountError(
            "Maximum discount must be equal to or geater than 0%"
          );
        } else {
          values.pay_after_dis =
            packagePrice - (packagePrice / 100) * discount_price;
          setDiscountError("");
        }
      } else if (packagePrice > 0) {
        if (discount_price > packagePrice) {
          values.pay_after_dis = "0";
          setDiscountError(
            "Maximum discount must be equal to or less than Package Full Price:" +
              packagePrice
          );
        } else if (discount_price < 0) {
          values.pay_after_dis = "0";
          setDiscountError(
            "Maximum discount must be equal to or geater than 0"
          );
        } else {
          values.pay_after_dis = packagePrice - discount_price;
          setDiscountError("");
        }
      } else if (discount_price < 0) {
        values.pay_after_dis = "0";
        setDiscountError("Maximum discount must be equal to or geater than 0");
      } else {
        setDiscountError("");
      }
    } else if (discount_price < 0) {
      values.pay_after_dis = "0";
      setDiscountError("Maximum discount must be equal to or geater than 0");
    } else {
      values.pay_after_dis = "0";
      setDiscountError("");
    }
  };

  const sellTrainPkg = async (values) => {
    if (paySplitError === "" && payAfterError === "" && discountError === "") {
      setLoading(true);
      try {
        const finalPrice = values.package_full_price || membershipFee;
        const responce = await UserServices.trainerPkgSell(
          branch_id,
          id,
          endDate,
          finalPrice,
          "2",
          values
        );
        console.log(responce);
        toast.success("Package Added!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
        setTimeout(() => {
          props.cart();
          props.catagry();
          // window.location.reload(true);
        }, 1500);
      } catch (err) {
        toast.error("Unproccessable content!", { position: "top-center" });
        console.log(err);
        setLoading(false);
      }
    }
  };

  const initialValues = {
    client_name: clientName,
    trainer: "",
    trainerPkgType: "",

    pkgType: "",
    qty: "1",
    discount_type: "Amount",
    discount_amount: "0",
    pay_after_dis: "0",
    package_full_price: "0",

    sdate: startDate,
    approveBy: "",
    referencedBy: "",
    salesnotes: "",
    salesdate: dateSelected,
  };
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: trainerPkgSell,
      onSubmit: (values, action) => {
        sellTrainPkg(values);
      },
    });
  return (
    <form onSubmit={handleSubmit}>
      <>
        <div className="card-header py-3">
          <h5 className="mb-0 font-20">Sell Trainer Package</h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  New Clients <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={clientName}
                  disabled={true}
                />
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  Available Trainers <span className="text-danger">*</span>
                </label>

                {trainerNames.length ? (
                  <select
                    className="form-select"
                    name="trainer"
                    value={values.trainer}
                    onChange={(e) => {
                      handleChange(e);
                      getTrainerPkgs(e);
                      values.trainerPkgType = "";
                      values.pkgType = "";
                      values.qty = "1";
                      setEndDate(dateSelected);
                      setMembershipFee("");
                      values.package_full_price = "";
                      values.discount_amount = "";
                      setDiscountError("");
                      setPaySplitError("");
                      setPayAfterError("");
                      values.pay_after_dis = "0";
                      values.payment_rec = "";
                      values.payment_pend = "";
                      values.payment_split = "";
                      values.payment_split_pend = "";
                    }}
                    onBlur={handleBlur}
                  >
                    {trainerNames.map((el, index) => {
                      return (
                        <option key={index} value={el.id}>
                          {el.name}
                        </option>
                      );
                    })}
                  </select>
                ) : (
                  <select
                    className="form-select"
                    name="trainer"
                    value={values.trainer}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option>Select Trainer</option>
                  </select>
                )}

                {errors.trainer && touched.trainer ? (
                  <p className="text-danger">{errors.trainer}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  Package Type <span className="text-danger">*</span>
                </label>

                {trainerPkgsTypes.length ? (
                  <select
                    className="form-select"
                    name="trainerPkgType"
                    value={values.trainerPkgType}
                    onChange={(e) => {
                      handleChange(e);
                      getPkgTypes(e);
                      setEndDate(dateSelected);
                      setMembershipFee("");
                      values.package_full_price = "";
                      values.pkgType = "";
                      values.qty = "1";
                      values.discount_amount = "";
                      setDiscountError("");
                      setPaySplitError("");
                      setPayAfterError("");
                      values.pay_after_dis = "0";
                      values.payment_rec = "";
                      values.payment_pend = "";
                      values.payment_split = "";
                      values.payment_split_pend = "";
                    }}
                    onBlur={handleBlur}
                  >
                    {trainerPkgsTypes.map((el, index) => {
                      return (
                        <option key={index} value={el.id}>
                          {el.name}
                        </option>
                      );
                    })}
                  </select>
                ) : (
                  <select
                    className="form-select"
                    name="trainerPkgType"
                    value={values.trainerPkgType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option>Select Package Type</option>
                  </select>
                )}

                {errors.trainerPkgType && touched.trainerPkgType ? (
                  <p className="text-danger">{errors.trainerPkgType}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  Trainer Package <span className="text-danger">*</span>
                </label>

                {pakagesTypes.length ? (
                  <select
                    className="form-select"
                    name="pkgType"
                    value={values.pkgType}
                    onChange={(e) => {
                      handleChange(e);
                      getPkgFee(e);

                      values.discount_amount = "";
                      setDiscountError("");
                      setPaySplitError("");
                      setPayAfterError("");
                      values.pay_after_dis = "0";
                      values.payment_rec = "";
                      values.payment_pend = "";
                      values.payment_split = "";
                      values.payment_split_pend = "";
                      values.sdate = startDate;
                      values.package_full_price = membershipFee;
                    }}
                    onBlur={handleBlur}
                  >
                    {pakagesTypes.map((el, index) => {
                      return (
                        <option key={index} value={el.id}>
                          {el.name}
                        </option>
                      );
                    })}
                  </select>
                ) : (
                  <select
                    className="form-select"
                    name="pkgType"
                    value={values.pkgType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option>Select Trainer Packages</option>
                  </select>
                )}

                {errors.pkgType && touched.pkgType ? (
                  <p className="text-danger">{errors.pkgType}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  Start Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Enter Start date"
                  name="sdate"
                  value={values.sdate}
                  onChange={(e) => {
                    handleChange(e);
                    changeStartDate(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.sdate && touched.sdate ? (
                  <p className="text-danger">{errors.sdate}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  End Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="Enter End date"
                  value={endDate}
                  disabled={true}
                />
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">Quantity</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Quantity"
                  name="qty"
                  value={values.qty}
                  onChange={(e) => {
                    handleChange(e);
                    changeQty(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.qty && touched.qty ? (
                  <p className="text-danger">{errors.qty}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Package Full Price <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="package_full_price"
                  value={values.package_full_price || membershipFee}
                  onChange={(e) => {
                    handleChange(e);
                    setMembershipFee(e.target.value);
                    // Recalculate discount if discount amount exists
                    if (values.discount_amount && values.discount_amount !== "") {
                      const discountEvent = { target: { value: values.discount_amount } };
                      verifyDiscount(discountEvent);
                    }
                  }}
                  onBlur={handleBlur}
                />
                {errors.package_full_price && touched.package_full_price ? (
                  <p className="text-danger">{errors.package_full_price}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label className="form-label">
                  Discount Type <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  name="discount_type"
                  value={values.discount_type}
                  onChange={(e) => {
                    handleChange(e);
                    values.discount_amount = "";
                    setDiscountError("");
                    setPaySplitError("");
                    setPayAfterError("");
                    values.pay_after_dis = "0";
                    values.payment_rec = "";
                    values.payment_pend = "";
                    values.payment_split = "";
                    values.payment_split_pend = "";
                  }}
                  onBlur={handleBlur}
                >
                  <option value="">Select Discount Type</option>
                  <option value="Percentage">Percentage</option>
                  <option value="Amount">Amount</option>
                </select>
                {errors.discount_type && touched.discount_type ? (
                  <p className="text-danger">{errors.discount_type}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Discount <span className="text-danger">*</span>
                </label>
                <input
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  type="number"
                  name="discount_amount"
                  value={values.discount_amount}
                  onChange={(e) => {
                    handleChange(e);
                    verifyDiscount(e);
                    setPaySplitError("");
                    setPayAfterError("");
                    values.payment_rec = "";
                    values.payment_pend = "";
                    values.payment_split = "";
                    values.payment_split_pend = "";
                  }}
                  onBlur={handleBlur}
                />

                {discountError !== "" ? (
                  <p className="text-danger">{discountError}</p>
                ) : null}

                {errors.discount_amount && touched.discount_amount ? (
                  <p className="text-danger">{errors.discount_amount}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Payable Amount After Discount
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="pay_after_dis"
                  value={values.pay_after_dis}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  disabled={true}
                />

                {errors.pay_after_dis && touched.pay_after_dis ? (
                  <p className="text-danger">{errors.pay_after_dis}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Discount Approve By
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="approveBy"
                  value={values.approveBy}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.approveBy && touched.approveBy ? (
                  <p className="text-danger">{errors.approveBy}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Referenced By
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="referencedBy"
                  value={values.referencedBy}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.referencedBy && touched.referencedBy ? (
                  <p className="text-danger">{errors.referencedBy}</p>
                ) : null}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Sales Notes
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="salesnotes"
                  value={values.salesnotes}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.salesnotes && touched.salesnotes ? (
                  <p className="text-danger">{errors.salesnotes}</p>
                ) : null}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group custom-group">
                <label htmlFor="form-label" className="form-label">
                  Sale Date
                </label>
                <input
                  className="form-control"
                  type="date"
                  name="salesdate"
                  value={values.salesdate}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                />

                {errors.salesdate && touched.salesdate ? (
                  <p className="text-danger">{errors.salesdate}</p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </>

      <div className="col-12 text-center mb-3">
        <button
          type="submit"
          className="btn btn-primary px-5 mb-1 me-2 addclient-button"
        >
          Sell Trainer Package
        </button>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </form>
  );
}
